<template>
    <div>
        <h3 class="page-block__title">
            {{ trans('profile.address_label') }}
        </h3>
        <div class="layout" v-if="customer.city">
            <div class="layout__item u-1/4-desk">
                <span class="page-block__item-content-title">
                    {{ trans('profile.address.city') }}
                </span>
            </div>
            <!--
         -->
            <div class="layout__item u-3/4-desk">
                {{ customer.city }}
            </div>
        </div>
        <div class="layout" v-if="customer.country_code">
            <div class="layout__item u-1/4-desk">
                <span class="page-block__item-content-title">
                    {{ trans('profile.address.country_code') }}
                </span>
            </div>
            <!--
         -->
            <div class="layout__item u-3/4-desk">
                {{ customer.country_code }}
            </div>
        </div>
        <div class="layout" v-if="customer.province">
            <div class="layout__item u-1/4-desk">
                <span class="page-block__item-content-title">
                    {{ trans('profile.address.province') }}
                </span>
            </div>
            <!--
         -->
            <div class="layout__item u-3/4-desk">
                {{ customer.province }}
            </div>
        </div>
        <div class="layout" v-if="customer.street_name">
            <div class="layout__item u-1/4-desk">
                <span class="page-block__item-content-title">
                    {{ trans('profile.address.street_name') }}
                </span>
            </div>
            <!--
         -->
            <div class="layout__item u-3/4-desk">
                {{ customer.street_name }}
            </div>
        </div>
        <div class="layout" v-if="customer.street_number">
            <div class="layout__item u-1/4-desk">
                <span class="page-block__item-content-title">
                    {{ trans('profile.address.street_number') }}
                </span>
            </div>
            <!--
         -->
            <div class="layout__item u-3/4-desk">
                {{ customer.street_number }}
            </div>
        </div>
        <div class="layout" v-if="customer.zip_code">
            <div class="layout__item u-1/4-desk">
                <span class="page-block__item-content-title">
                    {{ trans('profile.address.zip_code') }}
                </span>
            </div>
            <!--
         -->
            <div class="layout__item u-3/4-desk">
                {{ customer.zip_code }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProfileCustomerAddress',
    props: {
        customer: {
            type: Object,
            default: () => {}
        }
    }
};
</script>
